export const MAX_RESULTS = 10000;

// Layout
export const DRAWER_WIDTH = 240; // Largeur du sidebar en pixels
//Mission States
export const CREATED    = 100;
export const TODO       = 200;
export const INPROGRESS = 300;
export const TOSHIP     = 400;
export const TOSTORE    = 410;
export const FINISHED   = 500;
export const CANCELED   = 600;
export const INCOMPLETE = 700;
export const IMPOSSIBLE = 800;

//Location States
export const EMPTY_LOCATION = 1;
export const FULL_LOCATION = 2;
export const LOC_WITH_SAME_PRODUCT = 5;
export const AVAILABLE_STATUS = 1;
export const UNAVAILABLE_STATUS = 0;
//Picking States
export const PICKING_FINISHED   = 100;
export const PICKING_IMCOMPLETE = 200;
export const PICKING_INPROGRESS = 300;
//Stock
export const MIN_QTY   = 0;
export const MAX_QTY   = 10000;
export const MIN_PRICE   = 0;
export const MAX_PRICE   = 10000;

export const STATUS_OPTIONS = [
    { value: 100, label: 'created' },
    { value: 200, label: 'toDo' },
    { value: 300, label: 'inProgress' },
    { value: 400, label: 'toship' },
    { value: 410, label: 'tostore' },
    { value: 500, label: 'finished' },
    { value: 600, label: 'canceled' },
    { value: 700, label: 'incomplete' },
    { value: 800, label: 'impossible' },
];

export const LOCATION_STATUS_OPTIONS = [
  { value: 0, labelKey: 'locations.status.0' },
  { value: 1, labelKey: 'locations.status.1' },
];

export const REASON_OPTIONS = [
    { value: 1, label: 'product_not_found' },
    { value: 2, label: 'damaged_product' },
    { value: 3, label: 'lot_expired' },
    { value: 4, label: 'other_reason' },
];

export const MISSION_TYPES = [
    { value: 'order', label: 'order'},
    { value: 'inventory', label: 'inventory'},
    { value: 'replenishment', label: 'replenishment'},
];


export const MISSION_TABLE_HEADERS = {
  all: [
    { key: 'warehouse', label: 'missions.warehouse' },
    { key: 'id', label: 'missions.id' },
    { key: 'state', label: 'global.state' },
    { key: 'creation_date', label: 'global.creation_date' },
    { key: 'update_date', label: 'global.update_date' },
    { key: 'dfp', label: 'orders.plannedCompletionDate' },
    { key: 'operator', label: 'missions.operator' },
  ],

  order: [
    { key: 'warehouse', label: 'missions.warehouse' },
    { key: 'command_ref', label: 'orders.commandRef' },
    { key: 'state', label: 'global.state' },
    { key: 'creation_date', label: 'global.creation_date' },
    { key: 'update_date', label: 'global.update_date' },
    { key: 'dfp', label: 'orders.plannedCompletionDate' },
    { key: 'operator', label: 'global.operator' },
    { key: 'customer', label: 'orders.client' },
  ],

  inventory: [
    { key: 'warehouse', label: 'missions.warehouse' },
    { key: 'id', label: 'global.id' },
    { key: 'state', label: 'global.state' },
    { key: 'creation_date', label: 'global.creation_date' },
    { key: 'update_date', label: 'global.update_date' },
    { key: 'deadline', label: 'global.deadline' },
    { key: 'operator', label: 'global.operator' },
    { key: 'declination', label: 'global.product' },
  ],

  replenishment: [
    { key: 'warehouse', label: 'missions.warehouse' },
    { key: 'id', label: 'replenish.id' },
    { key: 'state', label: 'global.state' },
    { key: 'creation_date', label: 'global.creation_date' },
    { key: 'update_date', label: 'global.update_date' },
    { key: 'deadline', label: 'global.deadline' },
    { key: 'operator', label: 'global.operator' },
  ],

  shipment: [
    { key: 'shipment_ref', label: 'shipment.ref' },
    { key: 'state', label: 'global.state' },
    { key: 'shipment_date', label: 'shipment.date' },
    { key: 'carrier', label: 'shipment.carrier' },
    { key: 'box', label: 'shipment.box' },
    { key: 'documents', label: 'shipment.documents' },
  ],
};

